import { render, staticRenderFns } from "./Aba.vue?vue&type=template&id=093d9d30&scoped=true"
import script from "./Aba.vue?vue&type=script&lang=js"
export * from "./Aba.vue?vue&type=script&lang=js"
import style0 from "./Aba.vue?vue&type=style&index=0&id=093d9d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093d9d30",
  null
  
)

export default component.exports